export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a5cc962ded040a821af739a6d66a3818.jpg"
          alt="AAPEQ Training"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-5 sm:px-6 lg:px-8 py-32">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <div className="inline-block bg-[#F05954] text-white px-5 py-2 rounded-full text-xs font-bold uppercase tracking-wider mb-6">
                Exclusivo para Atuantes
              </div>
              
              <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black leading-tight mb-6">
                AAPEQ
                <span className="block text-[#F05954] mt-2">Primordial</span>
                <span className="block">Artistic Energy</span>
              </h1>
              
              <p className="text-lg lg:text-2xl text-gray-200 mb-6 leading-relaxed">
                A escola de alta performance fisica, energética, mental e telepatica exclusiva para profissionais e artistas atuantes que desejam elevar técnica, presença, resultado, consciência e resultados reais.
              </p>
              
              <p className="text-sm text-gray-300 mb-10 leading-relaxed">
                Somente para atuantes. Presencial obrigatório. Vagas limitadas.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pelo+site+e+quero+fazer+parte+da+AAPEQ+%E2%80%94+Hero"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#F05954] text-white px-8 py-4 rounded-full text-sm font-semibold hover:bg-[#d94943] transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer text-center"
                >
                  Quero Fazer Parte da AAPEQ
                </a>
                <button
                  onClick={() => scrollToSection('para-quem')}
                  className="border-2 border-white text-white px-8 py-4 rounded-full text-sm font-semibold hover:bg-white hover:text-[#262364] transition-all whitespace-nowrap cursor-pointer text-center"
                >
                  Ver Quem Pode Entrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Line */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#F05954] to-transparent"></div>
    </section>
  );
}
